module.exports = __webpack_public_path__ + "static/media/201CS225.3aa4fa54.jpg";